<script setup>
import { useRoute } from 'vue-router';
let searchQuery = defineModel();
const route = useRoute();
const clearSearch = () => searchQuery.value = '';

const submitSearch = () => {
  if (searchQuery.value && route.params.site_slug) {
    window.location = `/${route.params.site_slug}/search?query=${encodeURIComponent(searchQuery.value)}`;
  }
};

const { placeholder, rounded } = defineProps({
    placeholder: { type: String, default: 'Search' },
    rounded: { type: Boolean, default: false }
});
</script>

<template>
    <div class="flex justify-between items-center">
        <label class="flex items-center bg-white border border-gray-400 h-10 p-2 text-sm text-black relative" :class="rounded ? 'rounded-3xl' : 'rounded-md'">
            <font-awesome :icon="['fas', 'magnifying-glass']" class="h-4 w-8"/>
            <input
                class="placeholder-gray-500 outline-none text-base flex-grow"
                :placeholder="placeholder"
                v-model="searchQuery"
                @keyup.enter="submitSearch"
            />
            <button
                v-if="searchQuery"
                @click="clearSearch"
                class="text-gray-400 hover:text-gray-600 px-2 py-1 text-sm"
                type="button"
            >
                <font-awesome :icon="['fas', 'xmark']" class="h-4 w-4"/>
            </button>
        </label>
    </div>
</template>
